import { IAppState } from '../../../AppModulesWrapper';

import { EServiceId } from '../../types/reducers/publishTerms';

export const selectIsWithoutTopAndPremium = (state: IAppState): boolean => {
  return !state.servicePickerWidget.publishTerms.serviceIds.some(
    id => id === EServiceId.top || id === EServiceId.premium,
  );
};
